import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "create-documents" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 12H5",
    stroke: "#1A1D1E",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 19L5 12L12 5",
    stroke: "#1A1D1E",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Criar documento", -1)
const _hoisted_6 = {
  key: 0,
  class: "circular-radio"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Esse é um documento circular"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "(obrigatório)")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Marcando sim você enviará para todos os usuários dos setores/gabinete", -1)
const _hoisted_9 = { class: "radio-group" }
const _hoisted_10 = { class: "radio-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "radio-custom" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Sim", -1)
const _hoisted_13 = { class: "radio-label" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "radio-custom" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Não", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Assunto"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_17 = ["onMousedown"]
const _hoisted_18 = {
  key: 1,
  class: "exception"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Exceção"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Esse documento está fora do prazo padrão de envio. Para enviar, marque como sendo uma exceção.", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    checked: "true"
  }),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("p", null, "Enviar como exceção")
], -1)
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tipo de documento?"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_25 = ["onMousedown"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["id", "value", "checked", "onChange"]
const _hoisted_29 = ["for"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 5.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Responsáveis"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", null, "Quem irá ter acesso a esse documento? Você pode selecionar mais de uma pessoa.", -1)
const _hoisted_34 = ["id", "value", "checked", "onChange"]
const _hoisted_35 = ["for"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Titulo desse documento"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", null, "Dê um titulo claro para esse documento.", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h2", null, "Adicione esse número para facilitar a organização no sistema.", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Data limite"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo para o documento ser apreciado.", -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_44 = { class: "content-section" }
const _hoisted_45 = { class: "content-section__header" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Conteúdo desse documento"),
    /*#__PURE__*/_createTextVNode(" (obrigatório)")
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "Descreva os principais detalhes que irão ajudar aos interessados saber sobre o documento.")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_48 = {
  key: 0,
  class: "ai-panel"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "ai-prompt" }, "Descreva o que esse documento deve conter e a IA escreve um rascunho para você", -1)
const _hoisted_50 = { class: "ai-panel__footer" }
const _hoisted_51 = {
  key: 0,
  class: "ai-panel__quota"
}
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 1,
  class: "ai-compliance"
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_56 = {
  key: 0,
  class: "ai-compliance__result"
}
const _hoisted_57 = {
  key: 0,
  class: "ai-compliance__ok"
}
const _hoisted_58 = {
  key: 1,
  class: "ai-compliance__issues"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Palavras chaves"),
  /*#__PURE__*/_createTextVNode(" (opcional)")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h2", null, "Separe por vírgula, exemplo: férias, pagamento.", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Arquivo do documento"),
  /*#__PURE__*/_createTextVNode(" (opcional)")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h2", null, "Adicione um arquivo a esse documento, podendo ser DOC ou PDF.", -1)
const _hoisted_63 = {
  key: 0,
  class: "ai-classify"
}
const _hoisted_64 = ["disabled"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "ai-classify__hint" }, "A IA lê os arquivos anexados e sugere assunto, tipo, palavras-chave e citados.", -1)
const _hoisted_67 = { class: "spacing" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Citado(s) no(s) documento(s)"),
  /*#__PURE__*/_createTextVNode(" (opcional)")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h2", null, "Escreva nome e sobrenome dos participantes citados no(s) anexo(s) e separe por vírgula.", -1)
const _hoisted_70 = ["disabled"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "modal-date-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Data limite"),
  /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo para ser aceito.")
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "52",
    viewBox: "0 0 52 52",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18.1787 40.0616V18.0482C18.1787 17.1816 18.4387 16.3366 18.9154 15.6216L24.8304 6.82491C25.762 5.41657 28.0804 4.41991 30.052 5.15657C32.1754 5.87157 33.5837 8.2549 33.1287 10.3782L32.002 17.4632C31.9154 18.1132 32.0887 18.6982 32.457 19.1532C32.8254 19.5649 33.367 19.8249 33.952 19.8249H42.857C44.5687 19.8249 46.042 20.5182 46.9087 21.7316C47.732 22.9016 47.8837 24.4182 47.342 25.9566L42.012 42.1849C41.3404 44.8716 38.4154 47.0599 35.512 47.0599H27.062C25.6104 47.0599 23.5737 46.5616 22.642 45.6299L19.8687 43.4849C18.807 42.6832 18.1787 41.4049 18.1787 40.0616Z",
      fill: "#05CB95"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.288 13.8232H9.05634C5.69801 13.8232 4.33301 15.1232 4.33301 18.3299V40.1266C4.33301 43.3332 5.69801 44.6332 9.05634 44.6332H11.288C14.6463 44.6332 16.0113 43.3332 16.0113 40.1266V18.3299C16.0113 15.1232 14.6463 13.8232 11.288 13.8232Z",
      fill: "#05CB95"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "Tudo certo!"),
  /*#__PURE__*/_createElementVNode("h2", null, "Documento enviado com sucesso.")
], -1)

import { computed, onMounted, ref } from 'vue'
import { toast } from 'vue3-toastify'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import MySelect from '@/components/select/MySelect.vue'
import MySelectFilter from '@/components/select/MySelectFilter.vue'
import MyTags from '@/components/tag/MyTags.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import DocumentTypeEnum, { documentTypeTranslations } from '@/enums/DocumentTypeEnum'
import { OrganizationModel } from '@/models/OrganizationModel'
import { useAxios } from '@/api/axios'
import { UserModel } from '@/models/UserModel'
import TextEditor from '@/components/input/TextEditor.vue'
import FileUploader from '@/components/input/FileUploader.vue'
import DocumentSubjectModel from '@/models/DocumentSubjectModel'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import DocumentTagTypeEnum from '@/enums/DocumentTags/DocumentTagTypeEnum'
import { user as authenticatedUser, hasAiModule } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDocuments',
  setup(__props) {

const axios = useAxios()
const isChamber = computed(() => authenticatedUser.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const isFromAdminOrg = computed(() => users.value?.some((user) =>
  user.organization_id === authenticatedUser.value.organization_id &&
  user.roles?.some((role) => role.name === 'Super Admin' || role.name === 'Presidente')
))
const availableDocumentTypes = computed(() => {
  return (Object.values(DocumentTypeEnum) as DocumentTypeEnum[]).filter((type) => {
    return type !== DocumentTypeEnum.CIRCULAR
  })
})
const organizations = ref<OrganizationModel[]>()
const users = ref<UserModel[]>([])
const usersToTransfer = computed(() => users.value?.filter((user) => (selectedOrganizations.value.length ? selectedOrganizations.value.some((o) => o.id === user.organization_id) : true) &&
user.status === 'active'))
const documentSubjects = computed(() => {
    return documentSubjectsInitial.value?.filter(
      subject =>
        subject.name.toLowerCase().includes(documentSubjectSearch.value.toLowerCase())
    )
})
const documentSubjectsInitial = ref<DocumentSubjectModel[]>()
const isCreatingDocument = ref(false)
const documentSubjectSearch = ref('')

/* FORM */
const isCircularDoc = ref<boolean>(false)

function onCircularChange(): void {
  if (isCircularDoc.value) {
    onSelectDocumentType(DocumentTypeEnum.CIRCULAR)
  } else {
    selectedDocumentType.value = undefined
    selectedOrganizations.value = []
  }
}

const selectedSubject = ref<DocumentSubjectModel>()
const selectedDocumentType = ref<DocumentTypeEnum>()
const selectedOrganizations = ref<OrganizationModel[]>([])
const selectedResponsibles = ref<UserModel[]>([])
const isCircular = computed(() => selectedDocumentType.value === DocumentTypeEnum.CIRCULAR)
const title = ref<string>('')
const physicalDocumentNumber = ref<string>('')
const content = ref<string>('')
const documentFiles = ref<File[]>([])
const selectedLimitDate = ref('')
const limitDate = ref('')
const formattedLimitDate = computed(() => limitDate.value ? formatDate(limitDate.value) : undefined)
const mentions = ref<string[]>([])
const keywords = ref<string[]>([])
/* FORM */

/* AI COMPLIANCE REVIEW */
const isReviewingCompliance = ref<boolean>(false)
const complianceResult = ref<{ ok: boolean, issues: string[] }>()

function reviewCompliance (): void {
  if (!content.value || isReviewingCompliance.value) return

  isReviewingCompliance.value = true

  const body = new FormData()
  body.append('content', content.value)
  if (selectedDocumentType.value) body.append('type', selectedDocumentType.value as string)

  axios.post('/api/documents/ai-review-compliance', body)
    .then((res) => {
      complianceResult.value = res.data
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível revisar o documento com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isReviewingCompliance.value = false
      getAiContentUsage()
    })
}
/* AI COMPLIANCE REVIEW */

/* AI FILE CLASSIFICATION */
const isClassifyingFiles = ref<boolean>(false)

function classifyFilesWithAi (): void {
  if (!documentFiles.value.length || isClassifyingFiles.value) return

  isClassifyingFiles.value = true

  const payload = new FormData()
  documentFiles.value.forEach((file) => payload.append('files[]', file))

  axios.post('/api/documents/ai-classify-content', payload)
    .then((res) => {
      const suggestion = res.data

      if (suggestion.document_subject_id) {
        const subject = documentSubjectsInitial.value?.find((s) => s.id === suggestion.document_subject_id)
        if (subject) {
          selectedSubject.value = subject
          documentSubjectSearch.value = subject.name
        }
      }

      if (suggestion.type && !isCircularDoc.value) {
        onSelectDocumentType(suggestion.type)
      }

      if (suggestion.keywords?.length) {
        keywords.value = Array.from(new Set([...keywords.value, ...suggestion.keywords]))
      }

      if (suggestion.mentions?.length) {
        mentions.value = Array.from(new Set([...mentions.value, ...suggestion.mentions]))
      }

      toast.success('A IA preencheu os campos com base nos arquivos. Revise antes de enviar.')
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível classificar os arquivos com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isClassifyingFiles.value = false
      getAiContentUsage()
    })
}
/* AI FILE CLASSIFICATION */

/* AI CONTENT GENERATION */
const isAiPanelOpen = ref<boolean>(false)
const aiPrompt = ref<string>('')
const isGeneratingAiContent = ref<boolean>(false)
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()

function getAiContentUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function generateAiContent (): void {
  if (!aiPrompt.value.trim() || isGeneratingAiContent.value) return

  isGeneratingAiContent.value = true

  const payload = new FormData()
  payload.append('prompt', aiPrompt.value.trim())
  if (title.value) payload.append('title', title.value)
  if (selectedSubject.value?.name) payload.append('document_subject', selectedSubject.value.name)
  if (selectedDocumentType.value) payload.append('type', selectedDocumentType.value as string)

  axios.post('/api/documents/ai-generate-content', payload)
    .then((res) => {
      content.value = res.data.content
      aiPrompt.value = ''
      isAiPanelOpen.value = false
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar o conteúdo com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isGeneratingAiContent.value = false
      getAiContentUsage()
    })
}
/* AI CONTENT GENERATION */

const isDatePickerModalOpen = ref<boolean>(false)
const isCreateDocumentModalOpen = ref<boolean>(false)

const verifyValueSubject = (value: string) => {
  if (documentSubjectsInitial.value) {
    let onClear = false
    for (const [index, options] of documentSubjectsInitial.value.entries()) {
      if (options.name == value) {
        onClear = true
      }
    }
    if (!onClear) {
      documentSubjectSearch.value = ''
      selectedSubject.value = undefined
    }
  }
}

const formatDate = (date: string) => {
  const [year, mouth, day] = date.split('-')
  return `${day}/${mouth}/${year}`
}

function onSelectDocumentType (type: DocumentTypeEnum): void {
  selectedDocumentType.value = type
  if (type === DocumentTypeEnum.CIRCULAR) {
    selectedOrganizations.value = organizations.value ? [...organizations.value] : []
    selectedResponsibles.value = []
  } else {
    selectedOrganizations.value = []
    selectedResponsibles.value = []
  }
}

function toggleOrganization (organization: OrganizationModel, checked: boolean): void {
  if (checked) {
    if (!selectedOrganizations.value.some((o) => o.id === organization.id)) {
      selectedOrganizations.value.push(organization)
    }
  } else {
    selectedOrganizations.value = selectedOrganizations.value.filter((o) => o.id !== organization.id)
    selectedResponsibles.value = selectedResponsibles.value.filter((r) => r.organization_id !== organization.id)
  }
}

function toggleResponsible (responsible: UserModel, checked: boolean): void {
  if (checked) {
    if (!selectedResponsibles.value.some((r) => r.id === responsible.id)) {
      selectedResponsibles.value.push(responsible)
    }
  } else {
    selectedResponsibles.value = selectedResponsibles.value.filter((r) => r.id !== responsible.id)
  }
}

function createDocument (): void {
  isCreatingDocument.value = true

  const payload = new FormData()
  payload.append('document_subject_id', String(selectedSubject.value!.id))
  payload.append('type', selectedDocumentType.value as string)
  const orgIds = selectedOrganizations.value.map((org) => org.id)
  orgIds.forEach((id) => {
    payload.append('organization_ids[]', String(id))
  })
  if (isCircular.value) {
    const responsibleIds = users.value
      .filter((u) => u.status === 'active' && u.organization_id && orgIds.includes(u.organization_id))
      .map((u) => u.id)
    responsibleIds.forEach((id) => {
      payload.append('user_ids[]', String(id))
    })
  } else {
    selectedResponsibles.value.forEach((responsible) => {
      payload.append('user_ids[]', String(responsible.id))
    })
  }
  payload.append('title', title.value)
  payload.append('physical_document_number', physicalDocumentNumber.value)
  payload.append('limit_date', limitDate.value)
  payload.append('content', content.value)
  for (const key in documentFiles.value) {
    payload.append('files[]', documentFiles.value[key])
  }
  let tagsIndex = 0
  const appendTags = (items: string[], type: DocumentTagTypeEnum) => {
    items.forEach((item) => {
      payload.append(`tags[${tagsIndex}][title]`, item)
      payload.append(`tags[${tagsIndex}][type]`, type)
      tagsIndex++
    })
  }

  appendTags(mentions.value, DocumentTagTypeEnum.MENTION)
  appendTags(keywords.value, DocumentTagTypeEnum.KEYWORD)

  axios.post('/api/documents', payload)
    .then(() => {
      isCreateDocumentModalOpen.value = true
      resetForm()
    })
    .finally(() => isCreatingDocument.value = false)
}

function resetForm (): void {
  isCircularDoc.value = false
  documentSubjectSearch.value = ''
  selectedSubject.value = undefined
  selectedDocumentType.value = undefined
  selectedOrganizations.value = []
  selectedResponsibles.value = []
  title.value = ''
  physicalDocumentNumber.value = ''
  limitDate.value = ''
  content.value = ''
  documentFiles.value = []
  mentions.value = []
  keywords.value = []
  selectedLimitDate.value = ''
}

function getOrganizations () {
  axios.get('/api/organizations')
    .then((res) => {
      organizations.value = res.data
    })
}

function getUsers () {
  axios.get('/api/users')
    .then((res) => {
      users.value = res.data
    })
}

function getDocumentSubjects () {
  axios.get('/api/document-subjects', { params: { status: 'active' } })
    .then((res) => {
      documentSubjectsInitial.value = res.data
    })
}

onMounted(() => {
  getOrganizations()
  getUsers()
  getDocumentSubjects()
  getAiContentUsage()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        class: "back-button"
      }, _hoisted_4),
      _hoisted_5
    ]),
    (isFromAdminOrg.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "is-circular",
                value: true,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isCircularDoc).value = $event)),
                onChange: onCircularChange
              }, null, 544), [
                [_vModelRadio, isCircularDoc.value]
              ]),
              _hoisted_11,
              _hoisted_12
            ]),
            _createElementVNode("label", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "is-circular",
                value: false,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isCircularDoc).value = $event)),
                onChange: onCircularChange
              }, null, 544), [
                [_vModelRadio, isCircularDoc.value]
              ]),
              _hoisted_14,
              _hoisted_15
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _hoisted_16,
      _createVNode(MySelectFilter, {
        name: 'subject',
        value: documentSubjectSearch.value,
        modelValue: documentSubjectSearch.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((documentSubjectSearch).value = $event)),
        onBlur: verifyValueSubject
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentSubjects.value, (subject, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onMousedown: ($event: any) => {selectedSubject.value = subject; documentSubjectSearch.value = subject.name;}
            }, _toDisplayString(subject.name), 41, _hoisted_17))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "modelValue"])
    ]),
    (selectedSubject.value?.submission_end_day && (new Date().getDate() < selectedSubject.value?.submission_start_day || new Date().getDate() > selectedSubject.value?.submission_end_day))
      ? (_openBlock(), _createElementBlock("section", _hoisted_18, _hoisted_22))
      : _createCommentVNode("", true),
    (!isCircularDoc.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
          _hoisted_24,
          _createVNode(MySelect, {
            name: 'document_type',
            for: 'document_type',
            currentValue: selectedDocumentType.value ? _unref(documentTypeTranslations)[selectedDocumentType.value] : null
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDocumentTypes.value, (type, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onMousedown: ($event: any) => (onSelectDocumentType(type))
                }, _toDisplayString(_unref(documentTypeTranslations)[type]), 41, _hoisted_25))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createElementVNode("h1", null, [
        _createElementVNode("strong", null, _toDisplayString(isChamber.value ? 'Câmaras' : 'Setores/Gabinetes'), 1),
        _createTextVNode(" (obrigatório)")
      ]),
      (isCircular.value)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_26, "Esta circular será enviada para todos os " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores/gabinetes') + " marcados abaixo. Desmarque aqueles que não devem receber.", 1))
        : (_openBlock(), _createElementBlock("h2", _hoisted_27, "Quais " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores/gabinetes') + " irão ter acesso a esse documento? Você pode selecionar mais de um.", 1)),
      _createVNode(MyOptions, {
        currentValue: selectedOrganizations.value.length ? `${selectedOrganizations.value.length} ${isChamber.value ? 'câmara(s)' : 'setor(es)'} selecionado(s)` : 'Selecione'
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                id: 'organizations-' + index,
                value: organization.id,
                checked: selectedOrganizations.value.some((o) => o.id === organization.id),
                onChange: ($event: any) => (toggleOrganization(organization, ($event.target as HTMLInputElement).checked))
              }, null, 40, _hoisted_28),
              _createElementVNode("label", {
                for: 'organizations-' + index
              }, [
                _hoisted_30,
                _createElementVNode("p", null, _toDisplayString(organization.name), 1)
              ], 8, _hoisted_29)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["currentValue"])
    ]),
    (!isCircular.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
          _hoisted_32,
          _hoisted_33,
          _createVNode(MyOptions, {
            currentValue: selectedResponsibles.value.length ? `${selectedResponsibles.value.length} responsável(is) selecionado(s)` : 'Selecione'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersToTransfer.value, (responsible, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: index
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: 'responsible-' + index,
                    value: responsible.id,
                    checked: selectedResponsibles.value.some((r) => r.id === responsible.id),
                    onChange: ($event: any) => (toggleResponsible(responsible, ($event.target as HTMLInputElement).checked))
                  }, null, 40, _hoisted_34),
                  _createElementVNode("label", {
                    for: 'responsible-' + index
                  }, [
                    _hoisted_36,
                    _createElementVNode("p", null, _toDisplayString(responsible.name) + " " + _toDisplayString(responsible.last_name), 1)
                  ], 8, _hoisted_35)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _hoisted_37,
      _hoisted_38,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Ex: OFICIO 25 - SOLICITAÇÃO DE FALTAS",
        name: "title-document",
        id: "title-document",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((title).value = $event))
      }, null, 512), [
        [_vModelText, title.value]
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h1", null, [
        _createElementVNode("strong", null, _toDisplayString(isChamber.value ? 'Número de documento' : 'Número do ofício ou portaria'), 1),
        _createTextVNode(" (obrigatório)")
      ]),
      _hoisted_39,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Ex: 1011",
        name: "title-document",
        id: "title-document",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((physicalDocumentNumber).value = $event))
      }, null, 512), [
        [_vModelText, physicalDocumentNumber.value]
      ])
    ]),
    _createElementVNode("section", null, [
      _hoisted_40,
      _hoisted_41,
      _createElementVNode("label", {
        class: "date-picker-label",
        for: "date-limit-document",
        onClick: _cache[6] || (_cache[6] = ($event: any) => {isDatePickerModalOpen.value = true;})
      }, [
        _createElementVNode("input", {
          type: "text",
          placeholder: "Selecione uma data",
          name: "date-limit-document",
          id: "date-limit-document",
          value: formattedLimitDate.value ? formattedLimitDate.value : '',
          readonly: ""
        }, null, 8, _hoisted_42),
        _hoisted_43
      ])
    ]),
    _createElementVNode("section", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        (_unref(hasAiModule))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ai-toggle-button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (isAiPanelOpen.value = !isAiPanelOpen.value))
            }, [
              _hoisted_47,
              _createTextVNode(" Gerar com IA ")
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(hasAiModule) && isAiPanelOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _hoisted_49,
            _withDirectives(_createElementVNode("textarea", {
              id: "ai-prompt",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((aiPrompt).value = $event)),
              rows: "3",
              placeholder: "Ex: Um ofício solicitando a liberação de verba para reforma da escola municipal, com prazo de resposta de 15 dias."
            }, null, 512), [
              [_vModelText, aiPrompt.value]
            ]),
            _createElementVNode("div", _hoisted_50, [
              (aiUsage.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(aiUsage.value.remaining) + " de " + _toDisplayString(aiUsage.value.limit) + " gerações restantes hoje", 1))
                : _createCommentVNode("", true),
              (!isGeneratingAiContent.value)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "button",
                    value: "Gerar conteúdo",
                    disabled: !aiPrompt.value.trim() || (aiUsage.value && aiUsage.value.remaining <= 0),
                    onClick: generateAiContent
                  }, null, 8, _hoisted_52))
                : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                    key: 2,
                    height: 40,
                    maxWidth: 160
                  }))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(TextEditor, {
        value: content.value,
        setValue: (value) => content.value = value
      }, null, 8, ["value", "setValue"]),
      (_unref(hasAiModule))
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              class: "ai-toggle-button",
              disabled: !content.value || isReviewingCompliance.value,
              onClick: reviewCompliance
            }, [
              _hoisted_55,
              _createTextVNode(" " + _toDisplayString(isReviewingCompliance.value ? 'Revisando...' : 'Revisar formalidades com IA'), 1)
            ], 8, _hoisted_54),
            (complianceResult.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  (complianceResult.value.ok)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Nenhuma formalidade pendente encontrada."))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(complianceResult.value.issues, (issue, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(issue), 1))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", null, [
      _hoisted_59,
      _hoisted_60,
      _createVNode(MyTags, {
        modelValue: keywords.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((keywords).value = $event)),
        name: 'keywords',
        placeholder: 'Digite a palavra chave'
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_61,
      _hoisted_62,
      _createVNode(FileUploader, {
        files: documentFiles.value,
        pushFile: (file) => documentFiles.value.push(file)
      }, null, 8, ["files", "pushFile"]),
      (_unref(hasAiModule) && documentFiles.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createElementVNode("button", {
              type: "button",
              class: "ai-toggle-button",
              disabled: isClassifyingFiles.value,
              onClick: classifyFilesWithAi
            }, [
              _hoisted_65,
              _createTextVNode(" " + _toDisplayString(isClassifyingFiles.value ? 'Analisando arquivos...' : 'Preencher automaticamente com IA'), 1)
            ], 8, _hoisted_64),
            _hoisted_66
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_67, [
      _hoisted_68,
      _hoisted_69,
      _createVNode(MyTags, {
        modelValue: mentions.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((mentions).value = $event)),
        name: 'mentions',
        placeholder: 'Digite nome e sobrenome'
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("nav", null, [
      (!isCreatingDocument.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            value: "Enviar",
            onClick: createDocument,
            disabled: !selectedSubject.value || !selectedDocumentType.value || !selectedOrganizations.value.length || (!isCircular.value && !selectedResponsibles.value.length) || !title.value || !physicalDocumentNumber.value || !limitDate.value || !content.value
          }, null, 8, _hoisted_70))
        : (_openBlock(), _createBlock(SpinnerLoaderButton, {
            key: 1,
            height: 60,
            maxWidth: 464
          })),
      _createElementVNode("input", {
        type: "button",
        value: "Cancelar",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.go(-1)))
      })
    ]),
    _createVNode(MyModal, {
      width: '341px !important',
      height: '517px !important',
      className: 'date-limit',
      isOpen: isDatePickerModalOpen.value,
      toggleModal: (v) => isDatePickerModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_71,
        _createVNode(MyDatePicker, {
          min: { day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() },
          name: 'limit',
          setValue: (date) => selectedLimitDate.value = date
        }, null, 8, ["min", "setValue"]),
        _createElementVNode("input", {
          type: "button",
          value: "Aplicar data",
          onClick: _cache[12] || (_cache[12] = ($event: any) => {limitDate.value = selectedLimitDate.value; isDatePickerModalOpen.value = false})
        })
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      width: '330px !important',
      height: '179px !important',
      isOpen: isCreateDocumentModalOpen.value,
      "class-name": 'confirm-create-document',
      toggleModal: (v) => isCreateDocumentModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_72
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})